import React from 'react';
import AddressIcon from 'material-ui/svg-icons/action/explore';
import MailIcon from 'material-ui/svg-icons/communication/mail-outline';
import CallIcon from 'material-ui/svg-icons/communication/call';
import RaisedButton from 'material-ui/RaisedButton';
import config from "../../../../config";
import { withRouter} from 'react-router-dom';

class Block1 extends React.Component {

    render() {
        const e = this.props.entreprise;
        return (
            <div className={'row'} style={{marginBottom:10, marginTop:10}}>
                <div className={'col'} style={{display:'inline-flex', verticalAlign:'middle'}}>
                    <div style={{paddingTop:17, paddingRight:8}}>
                        <AddressIcon style={{width:18, height:18}}/>
                    </div>
                    <address>
                        {e.nom}<br/>
                        {e.adresse}<br/>
                        {e.ville+', '+e.cp}
                    </address>
                </div>
                <div className={'col'}>
                    <div style={{display:'inline-flex', verticalAlign:'middle'}}>
                        <MailIcon style={{width:18, height:18, marginRight:8}}/>{e.email}
                    </div><br/><br/>
                    <div style={{display:'inline-flex', verticalAlign:'middle'}}>
                        <CallIcon style={{width:18, height:18, marginRight:8}}/>{e.tel}
                    </div>
                </div>
                <div className={'col align-self-center'} >
                    {e.id && <img alt='logo'
                                  height='48px'
                                  src={config.upload_path+e.logo+'?randomToken='+e.logoRandomToken}
                    />}
                </div>
                <div className={'col-sm-12'}>
                    <RaisedButton
                        label={'Modifier ces données'}
                        primary={true}
                        onClick={()=>this.props.history.push('/entreprise/edition_generale')}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(Block1);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/indexBlocks/Block1.js